import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "Framer's Bench";
const BASE_DESC =
  "Free frame and mat calculator for artists, photographers and framers. Work out mat borders, matboard cut sizes, glass and frame dimensions — and stop your frames not fitting after cutting.";

export function Seo({ title, description, path = "/", faq, image }) {
  const fullTitle = title ? `${title} · ${SITE}` : `${SITE} — Precision Frame & Mat Calculator`;
  const desc = description || BASE_DESC;
  const url = `https://frame-calc-4.emergent.host${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content={image ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {faq && faq.length > 0 && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faq.map((f) => ({
              "@type": "Question",
              name: f.q,
              acceptedAnswer: { "@type": "Answer", text: f.a + (f.list ? " " + f.list.join(" ") : "") },
            })),
          })}
        </script>
      )}
    </Helmet>
  );
}
